import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TransportAgentInfoComponent = ({ transportAgents, salesOrders, vehicles, onInnerFormChange, selectedAgents }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="TransportAgentNumber"
                        name="TransportAgentNumber"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TransportAgentNumber',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.TransportAgentInfo?.TransportAgentNumber}
                    />
                    <InputContainer
                        label="Vehicle"
                        labelField="VehicleName"
                        list={vehicles}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.VehicleId',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                         optionName='Choose Vehicle'
                        type="select"
                        value={selectedAgents?.TransportAgentInfo?.VehicleId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="SalesOrder"
                        labelField="ShipmentPId"
                        list={salesOrders}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.SalesOrderId',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        optionName='Choose SalesOrder'
                        type="select"
                        value={selectedAgents?.TransportAgentInfo?.SalesOrderId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="TransportAgent"
                        labelField="Name"
                        list={transportAgents}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TransportAgentId',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        optionName='Choose TransportAgent'
                        type="select"
                        value={selectedAgents?.TransportAgentInfo?.TransportAgentId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="From Location"
                        name="FromLocation"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.FromLocation',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.TransportAgentInfo?.FromLocation}
                    />
                    <InputContainer
                        label="To Location"
                        name="To Location"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.ToLocation',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.TransportAgentInfo?.ToLocation}
                    />
                    <InputContainer
                        label="InvoiceNumber"
                        name="InvoiceNumber"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.InvoiceNumber',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.TransportAgentInfo?.InvoiceNumber}
                    />
                    <InputContainer
                        label="TotalDistance"
                        name="TotalDistance"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TotalDistance',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.TransportAgentInfo?.TotalDistance}
                    />
                    <InputContainer
                        label="TotalWeight"
                        name="TotalWeight"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TotalWeight',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.TransportAgentInfo?.TotalWeight}
                    />
                    <InputContainer
                        label="TotalVolume"
                        name="TotalVolume"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TotalVolume',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.TransportAgentInfo?.TotalVolume}
                    />
                    <InputContainer
                        label="TotalPieces"
                        name="TotalPieces"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'TransportAgentInfo.TotalPieces',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.TransportAgentInfo?.TotalPieces}
                    />
                    <InputContainer
                        label="AnyDangerousItem"
                        name="IsAnyDangerousItem"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'TransportAgentInfo.IsAnyDangerousItem',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.TransportAgentInfo?.IsAnyDangerousItem}
                    />
                    <InputContainer
                        label="Available"
                        name="IsAvailable"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'TransportAgentInfo.IsAvailable',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.TransportAgentInfo?.IsAvailable}
                    />
                    <InputContainer
                        label="CODCollectionEnabled"
                        name="IsCODCollectionEnabled"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'TransportAgentInfo.IsCODCollectionEnabled',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.TransportAgentInfo?.IsCODCollectionEnabled}
                    />
                    <InputContainer
                        label="CODCollectionLimit"
                        name="CODCollectionLimit"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'TransportAgentInfo.CODCollectionLimit',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.TransportAgentInfo?.CODCollectionLimit}
                    />
                    <InputContainer
                        label="AutoAssignJob"
                        name="IsAutoAssignJob"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'TransportAgentInfo.IsAutoAssignJob',
                                selectedAgents?.TransportAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.TransportAgentInfo?.IsAutoAssignJob}
                    />
                </div>
            }
            expandedPanel="transportAgentInfo"
            headerTitle="TransportAgent Info"
        />
    </>
)
export default TransportAgentInfoComponent;
